export const categories = [
  {
    id: 1,
    name: "Shoes",
    namePt: "Tênis",
    description: "Tênis importados da China",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Diagonal%20side%20view%20product%20photography%20of%20a%20single%20pair%20of%20chunky%20dad%20sneakers%20in%20off%20white%20and%20sage%20green%20colorway%20placed%20on%20a%20raw%20concrete%20surface%20with%20a%20dried%20palm%20leaf%20shadow%20casting%20across%2C%20bright%20morning%20sunlight%2C%20editorial%20fashion%20catalog%20style%2C%20sharp%20detail%20on%20texture&width=800&height=800&seq=cat-v2-shoes-01&orientation=squarish",
    count: "450+",
  },
  {
    id: 2,
    name: "Hoodies/Sweaters",
    namePt: "Moletons/Suéteres",
    description: "Moletons e suéteres",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Hanging%20on%20a%20wooden%20hanger%20against%20a%20soft%20terracotta%20colored%20wall%2C%20a%20heavyweight%20heather%20grey%20hoodie%20with%20drawstrings%20dangling%2C%20side%20lighting%20from%20a%20nearby%20window%20creating%20dramatic%20fabric%20texture%20highlights%2C%20minimalist%20boutique%20display%20photography&width=800&height=800&seq=cat-v2-hoodies-02&orientation=squarish",
    count: "380+",
  },
  {
    id: 3,
    name: "T-Shirts",
    namePt: "Camisetas",
    description: "Camisetas de alta qualidade",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20product%20shot%20of%20a%20vintage%20washed%20black%20band%20t-shirt%20with%20subtle%20graphic%20print%20folded%20on%20a%20distressed%20wooden%20table%2C%20warm%20afternoon%20sunlight%20streaming%20through%20gauze%20curtains%2C%20soft%20bokeh%20background%2C%20indie%20fashion%20editorial%20mood&width=800&height=800&seq=cat-v2-tshirts-03&orientation=squarish",
    count: "520+",
  },
  {
    id: 4,
    name: "Jackets",
    namePt: "Jaquetas",
    description: "Jaquetas importadas",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Worn%20on%20a%20mannequin%20bust%2C%20a%20vintage%20distressed%20brown%20leather%20aviator%20jacket%20with%20shearling%20collar%2C%20positioned%20against%20an%20industrial%20brick%20wall%20with%20soft%20spotlight%20from%20above%2C%20high%20contrast%20editorial%20product%20photography%2C%20rich%20leather%20texture%20visible&width=800&height=800&seq=cat-v2-jackets-04&orientation=squarish",
    count: "310+",
  },
  {
    id: 5,
    name: "Pants/Shorts",
    namePt: "Calças/Shorts",
    description: "Calças e shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Laid%20flat%20aerial%20view%20of%20wide%20leg%20light%20wash%20denim%20jeans%20with%20raw%20hem%2C%20styled%20with%20a%20thin%20brown%20belt%2C%20on%20a%20whitewashed%20floorboard%20surface%20with%20morning%20light%20from%20the%20left%2C%20clean%20Scandinavian%20minimalist%20product%20photography&width=800&height=800&seq=cat-v2-pants-05&orientation=squarish",
    count: "280+",
  },
  {
    id: 6,
    name: "Headwear",
    namePt: "Chapéus/Bonés",
    description: "Chapéus e bonés",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Top%20down%20view%20of%20a%20forest%20green%20bucket%20hat%20with%20embroidered%20logo%20resting%20on%20a%20woven%20rattan%20surface%2C%20surrounded%20by%20a%20few%20dried%20eucalyptus%20leaves%2C%20bright%20natural%20daylight%2C%20organic%20lifestyle%20product%20photography%2C%20earthy%20tones&width=800&height=800&seq=cat-v2-headwear-06&orientation=squarish",
    count: "190+",
  },
  {
    id: 7,
    name: "Sets",
    namePt: "Conjuntos",
    description: "Conjuntos completos",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Two%20piece%20coordinated%20knit%20set%20in%20warm%20camel%20tone%2C%20top%20and%20matching%20shorts%2C%20artfully%20draped%20over%20a%20minimal%20wooden%20stool%2C%20soft%20diffused%20studio%20lighting%2C%20elegant%20editorial%20loungewear%20photography%2C%20cozy%20yet%20refined%20aesthetic&width=800&height=800&seq=cat-v2-sets-07&orientation=squarish",
    count: "160+",
  },
  {
    id: 8,
    name: "Underwear/Underpants",
    namePt: "Roupa Íntima",
    description: "Roupas íntimas",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Neatly%20stacked%20organic%20cotton%20underwear%20in%20soft%20dusty%20pink%20and%20oatmeal%20colors%20on%20a%20marble%20tray%2C%20with%20a%20small%20sprig%20of%20lavender%20beside%20them%2C%20gentle%20morning%20light%20from%20a%20window%2C%20clean%20spa%20like%20product%20photography%2C%20delicate%20and%20airy&width=800&height=800&seq=cat-v2-underwear-08&orientation=squarish",
    count: "140+",
  },
  {
    id: 9,
    name: "Jersey",
    namePt: "Camisas de Time",
    description: "Camisas de futebol",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Framed%20on%20a%20dark%20wall%20like%20art%2C%20a%20retro%20style%20soccer%20jersey%20in%20deep%20burgundy%20with%20gold%20accents%2C%20illuminated%20by%20a%20single%20gallery%20spotlight%20from%20above%2C%20dramatic%20shadows%2C%20collector%20grade%20product%20photography%2C%20museum%20quality%20presentation&width=800&height=800&seq=cat-v2-jersey-09&orientation=squarish",
    count: "220+",
  },
  {
    id: 10,
    name: "Accessories",
    namePt: "Acessórios",
    description: "Acessórios diversos",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Scattered%20on%20a%20dark%20slate%20surface%2C%20mixed%20silver%20tone%20chain%20necklaces%20and%20chunky%20rings%20catching%20bright%20side%20light%2C%20one%20piece%20resting%20on%20a%20small%20velvet%20pouch%2C%20editorial%20jewelry%20flat%20lay%20with%20dramatic%20highlights%2C%20luxe%20street%20style&width=800&height=800&seq=cat-v2-accessories-10&orientation=squarish",
    count: "300+",
  },
  {
    id: 11,
    name: "Bags",
    namePt: "Bolsas",
    description: "Bolsas e mochilas",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Leaning%20against%20a%20white%20wall%20on%20a%20polished%20concrete%20floor%2C%20a%20structured%20cognac%20brown%20leather%20crossbody%20bag%20with%20gold%20hardware%2C%20long%20shadow%20from%20late%20afternoon%20sun%2C%20modern%20minimalist%20product%20photography%20with%20geometric%20composition&width=800&height=800&seq=cat-v2-bags-11&orientation=squarish",
    count: "250+",
  },
  {
    id: 12,
    name: "Belts",
    namePt: "Cintos",
    description: "Cintos de couro",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Coiled%20in%20a%20perfect%20circle%20on%20a%20dark%20walnut%20wooden%20surface%2C%20a%20braided%20dark%20chocolate%20brown%20leather%20belt%20with%20an%20antique%20brass%20buckle%2C%20warm%20candlelight%20style%20illumination%2C%20rich%20textures%2C%20artisan%20craftsmanship%20product%20photography&width=800&height=800&seq=cat-v2-belts-12&orientation=squarish",
    count: "120+",
  },
  {
    id: 13,
    name: "Perfumes",
    namePt: "Perfumes",
    description: "Perfumes importados",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Three%20different%20sized%20frosted%20glass%20perfume%20bottles%20with%20rose%20gold%20caps%20arranged%20in%20a%20triangle%20on%20a%20mirrored%20surface%2C%20reflecting%20soft%20pink%20ambient%20light%2C%20a%20few%20rose%20petals%20delicately%20placed%2C%20luxury%20beauty%20editorial%20photography%2C%20glamorous%20and%20clean&width=800&height=800&seq=cat-v2-perfumes-13&orientation=squarish",
    count: "180+",
  },
  {
    id: 14,
    name: "Other Stuff",
    namePt: "Outros Itens",
    description: "Outros produtos diversos",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Eclectic%20arrangement%20of%20small%20lifestyle%20objects%20including%20a%20ceramic%20mug%2C%20keychain%2C%20stickers%2C%20and%20a%20woven%20bracelet%20on%20a%20cork%20board%20surface%2C%20bright%20daylight%20with%20slight%20shadow%2C%20fun%20and%20playful%20product%20flat%20lay%2C%20diverse%20and%20colorful%20yet%20cohesive&width=800&height=800&seq=cat-v2-other-14&orientation=squarish",
    count: "200+",
  },
];